import { useEffect, useRef } from "react";

type UseApiActionHandlerParams = {
  isPending: boolean;
  error: any;
  onSuccess?: () => void;
  onError?: () => void;
  enabled?: boolean;
};

export function useApiActionHandler({
  isPending,
  error,
  onSuccess,
  onError,
  enabled = true,
}: UseApiActionHandlerParams) {
  const wasPending = useRef(false);

  useEffect(() => {
    const finished = wasPending.current && !isPending;
    wasPending.current = isPending;

    if (!finished || !enabled) return;

    if (error) {
      onError?.();
    } else {
      onSuccess?.();
    }
  }, [isPending, error, enabled, onSuccess, onError]);
}
